import { TabsComponent } from './tabs';

// Tabs functionality for reviews
const reviewsTabs = new TabsComponent({
	containerSelector: '.reviews-tabs-container',
	buttonSelector: '[data-filter]',
	contentSelector: '[data-tab-content]',
	activeClass: 'active',
});

// Map functionality for location display
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import marker_icon_2x from 'leaflet/dist/images/marker-icon-2x.png';
import marker_icon from 'leaflet/dist/images/marker-icon.png';
import marker_shadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: marker_icon_2x,
	iconUrl: marker_icon,
	shadowUrl: marker_shadow,
});

export function initMap(containerId, lat, lng, address) {
	const map = L.map(containerId).setView([lat, lng], 16);

	// CartoDB Positron tile layer (light, clean style)
	L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
		attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>',
		subdomains: 'abcd',
		maxZoom: 18,
	}).addTo(map);

	const marker = L.marker([lat, lng]).addTo(map);
	marker.bindPopup(address);
}

// Initialize map when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	const el = document.getElementById('location-map');
	if (!el) return;

	const lat = parseFloat(el.dataset.lat);
	const lng = parseFloat(el.dataset.lng);
	const address = el.dataset.address;

	// Check if we have valid coordinates
	if (isNaN(lat) || isNaN(lng)) {
		console.warn('Invalid coordinates for location map:', { lat, lng });
		return;
	}

	initMap('location-map', lat, lng, address);
});
